const timelineData = [
  {
    text: "Cofounder and developer",
    date2: "February 2024 - now",
    paragraph: "ScrapegraphAI, Inc",
    first:
      "I created a company for making scraping with the use of the AI. Actually is top 200 open source project about AI in the world",
    second: "https://scrapegraphai.com",
    category: {
      tag: "Work",
      color: "#6a5acd",
    },
  },
  {
    text: "Assistant and tutor professor",
    date2: "October 2023 ‑ February 2024",
    paragraph: "University of Bergamo",
    first:
      "Teaching and tutoring for statistic course for computer science engineering",

    category: {
      tag: "Work",
      color: "#6a5acd",
    },
  },
  {
    text: "Internship",
    date2: "July 2023 - September 2023",
    paragraph: "Inxpect spa",
    first:
      "Main work: ML algorithm for labeling images and create new neural networks from a pre‑trained network. This company was named by Wired one of the top startup in Italy in 2022",
    category: {
      tag: "Work",
      color: "#6a5acd",
    },
  },
  {
    text: "Freelancer",
    date2: "May 2023 - June 2023",
    paragraph: "Demola Latvia",
    first: "Creation of a student portal with Ai Chatbot integration",
    second: "https://chatb-66bd4.web.app/#/",
    category: {
      tag: "Freelancing",
      color: "#6a5acd",
    },
  },
  {
    text: "Research grant",
    date2: "November 2022 - January 2023",
    paragraph: "University of Bergamo",
    first:
      "Creation of an equidistant grid map starting from an heterogeneous map for the AgrimOnIA project",
    category: {
      tag: "Work",
      color: "#6a5acd",
    },
  },
];

export default timelineData;
